<script>
	import { cn } from "./cn.js";
	// 커스텀 toggle-button 대체. 상태는 부모가 소유(checked prop) + on:click 포워딩.
	// ⚠️ `tw-p-0` 를 빼지 말 것 — preflight 가 꺼져 있어 <button> 이 브라우저 기본 여백(Chrome 좌우 6px)을 갖는다.
	//    그게 남으면 꺼진 상태에서 원이 왼쪽 끝에 안 붙고, 켜진 상태에선 오른쪽 밖으로 6px 삐져나온다.
	//    (콘솔 Webflow CSS·hub-admin.html 리셋 어느 쪽도 button 여백을 지우지 않는다)
	export let checked = false;
	let className = "";
	export { className as class };
</script>

<button
	type="button"
	role="switch"
	aria-checked={checked}
	class={cn(
		"tw-inline-flex tw-h-6 tw-w-11 tw-shrink-0 tw-cursor-pointer tw-items-center tw-rounded-full tw-border-2 tw-border-transparent tw-p-0 tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring",
		checked ? "tw-bg-primary" : "tw-bg-input",
		className,
	)}
	on:click
	{...$$restProps}
>
	<span
		class={cn(
			"tw-pointer-events-none tw-block tw-h-5 tw-w-5 tw-rounded-full tw-bg-white tw-shadow tw-transition-transform",
			checked ? "tw-translate-x-5" : "tw-translate-x-0",
		)}
	/>
</button>
